import { submitstep, postBiometrics, putBiometrics, blanksurvey, mynutritiondata } from '../api'

export const submitSurvey = async ({ commit, state, dispatch }, data) => {
  try {
    const res = await submitstep(data, state.activeSurvey)
    if (res && res instanceof Error) throw res
    await dispatch('getMe')
    commit('TOAST_ACCOUNT', 'Survey submitted!')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const submitBiometrics = async ({ commit, state, dispatch }, data) => {
  try {
    let res
    if (data._id) {
      res = await putBiometrics(data, data._id)
      if (res && res instanceof Error) throw res
      commit('TOAST_ACCOUNT', 'Biometrics updated!')
    } else {
      res = await postBiometrics(data)
      if (res && res instanceof Error) throw res
      commit('TOAST_ACCOUNT', 'Biometrics submitted!')
    }
    await dispatch('getMe')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getBlankSurvey = async ({ dispatch, commit }, data) => {
  try {
    const res = await blanksurvey()
    if (res && res instanceof Error) throw res
    const surveys = res.data.results
    if (surveys.length > 0) {
      commit('NUTRITIONSURVEYFIELDSET', surveys[0])
    }
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getNutritionData = async ({ commit }, data) => {
  try {
    const res = await mynutritiondata()
    if (res && res instanceof Error) throw res
    commit('NUTRITIONSURVEYFIELDSET', res.data)
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/app/store/surveys/actions.js